import React from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import InputRow from '../elements/InputRow'
import InputRowReadOnly from '../elements/InputRowReadOnly'

const options = {
    postUrl: '/api/postResetPasswordVoip',
    success: 'Success! Your password has been updated.'
}
const state = {}

class VoipResetPasswordForm extends React.Component {
    componentDidMount () {
        this.props.setDynamicValues({
            serviceId: this.props.serviceId
        })
    }

    handleInputChange (event) {
        this.props.handleInputChange(event)
    }

    handleSubmit (event) {
       this.props.handleSubmit(event)
    }

    handleKeyDown (event) {
        this.props.handleKeyDown(event)
    }

    render () {
        return (
            <form onSubmit={this.handleSubmit.bind(this)} onKeyDown={this.handleKeyDown.bind(this)} className='mb-3'>
               <InputRowReadOnly
                   label='My VoIP username'
                   value={this.props.username}
               />
               <InputRowReadOnly
                   label='Proxy server'
                   value={this.props.proxyServer}
               />
               <InputRow
                   label='New VoIP password'
                   name='password'
                   type='password'
                   value={this.props.values.password}
                   errors={this.props.errors}
                   handleChange={this.handleInputChange.bind(this)}
               />

                {this.props.children}

                <div className='mt-4'>
                    <Button title='Update Details' action={this.props.handleSubmit} />
                </div>
            </form>
        )
    }
}

export default FormHOC(VoipResetPasswordForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/VoipResetPasswordForm.js